import { Code, Name, Price } from "../../../utils/Constant";

export const tableHeader = [Name,Code,Price]

export const tableBody = [
    {
        img:"10",
        name:"Pot",
        number:"100",
        coupon:"Coupon Code",
        code:"1PIX001",
        percentage:"-65%",
        amount:"$99.00"
    },
    {
        img:"11",
        name:"iphone",
        number:"150 Item",
        coupon:"Coupon Code",
        code:"HT463",
        percentage:"-15%",
        amount:"$65.00"
    },
    {
        img:"12",
        name:"Headphone",
        number:"513 Item",
        coupon:"Coupon Code",
        code:"LP72K",
        percentage:"-92%",
        amount:"$84.00"
    },
    {
        img:"13",
        name:"Glass",
        number:"629 Item",
        coupon:"Coupon Code",
        code:"REA75",
        percentage:"-37%",
        amount:"$24.00"
    },
    {
        img:"14",
        name:"Watch",
        number:"896 Item",
        coupon:"Coupon Code",
        code:"XRT839",
        percentage:"-91%",
        amount:"$91.00"
    }
]